module.exports = __webpack_public_path__ + "images/img-1IyUYzc.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/bday-city-popup-bg-en.png
// module id = 1986
// module chunks = 0